'use client';
import { EventBus } from '@s7/event-bus';
import { objectEntries } from '@s7/utils';
import { AnalyticsTopic } from './AnalyticsTopic/AnalyticsTopic.js';
import { AnalyticsWorker } from './AnalyticsWorker/AnalyticsWorker.js';

var AnalyticsManager = function(options) {
    var createTopic = function createTopic(transform) {
        return AnalyticsTopic({
            bus: bus,
            transforms: [
                globalTransform,
                transform
            ]
        });
    };
    var globalTransform = options.transform, plugins = options.plugins, listeners = options.listeners;
    var bus = EventBus();
    var worker = AnalyticsWorker({
        bus: bus,
        plugins: plugins
    });
    /**
     * Прикрепляем слушателей шины до запуска.
     * */ if (listeners) {
        objectEntries(listeners).forEach(function(param) {
            var eventName = param[0], listener = param[1];
            bus.on(eventName, listener);
        });
    }
    /**
     * Запускаем инициализацию плагинов и прослушивание событий только на клиенте.
     * */ if (typeof window !== "undefined") {
        worker.init().listen();
    }
    var analyticsManager = {
        createTopic: createTopic
    };
    return analyticsManager;
};

export { AnalyticsManager };
